import { render } from "./MBPCheckbox.vue?vue&type=template&id=40716d24&scoped=true"
import script from "./MBPCheckbox.vue?vue&type=script&lang=js"
export * from "./MBPCheckbox.vue?vue&type=script&lang=js"

import "./MBPCheckbox.vue?vue&type=style&index=0&id=40716d24&scoped=true&lang=scss"

import exportComponent from "/var/www/mbp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40716d24"]])

export default __exports__